import React, { useEffect, useState } from 'react';
// [Web UX 3. csomag (D), 2026-10-04] A kérés-hibák szövege a közös `apiErrorMessage`-en át megy (a szerver magyar
// indoklása mindhárom törzs-alakból / hálózati hibánál magyar mondat / különben „<tartalék> (HTTP n)"),
// a nyers `err.response?.data?.message` helyett. Őr: `utils/__tests__/rawErrorMessages.guard.test.ts`.
import { apiErrorMessage } from '../utils/apiErrors';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, CircularProgress, Button, Container, Alert } from '@mui/material';
import { authService } from '../services/authService';
import { CheckCircle as CheckCircleIcon, Error as ErrorIcon } from '@mui/icons-material';

const VerifyEmail: React.FC = () => {
    const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
    const [message, setMessage] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const verifyToken = async () => {
            const searchParams = new URLSearchParams(location.search);
            const token = searchParams.get('token');

            if (!token) {
                setStatus('error');
                setMessage('Érvénytelen vagy hiányzó verifikációs token.');
                return;
            }

            try {
                await authService.verifyEmail(token);
                setStatus('success');
                setMessage('E-mail cím sikeresen megerősítve! Most már várhatod az adminisztrátor jóváhagyását.');
            } catch (error: any) {
                setStatus('error');
                setMessage(apiErrorMessage(error, 'Hiba történt az e-mail megerősítésekor.'));
            }
        };

        verifyToken();
    }, [location]);

    return (
        <Container component="main" maxWidth="sm">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Paper elevation={3} sx={{ p: 4, width: '100%', textAlign: 'center' }}>
                    {status === 'verifying' && (
                        <>
                            <CircularProgress size={60} sx={{ mb: 2 }} />
                            <Typography variant="h5">E-mail cím megerősítése folyamatban...</Typography>
                        </>
                    )}

                    {status === 'success' && (
                        <>
                            <CheckCircleIcon color="success" sx={{ fontSize: 60, mb: 2 }} />
                            <Typography variant="h5" gutterBottom>
                                Sikeres megerősítés!
                            </Typography>
                            <Alert severity="success" sx={{ mb: 3 }}>
                                {message}
                            </Alert>
                            <Button variant="contained" onClick={() => navigate('/belepes')}>
                                Tovább a bejelentkezéshez
                            </Button>
                        </>
                    )}

                    {status === 'error' && (
                        <>
                            <ErrorIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
                            <Typography variant="h5" gutterBottom>
                                Hiba történt
                            </Typography>
                            <Alert severity="error" sx={{ mb: 3 }}>
                                {message}
                            </Alert>
                            <Button variant="outlined" onClick={() => navigate('/')}>
                                Vissza a főoldalra
                            </Button>
                        </>
                    )}
                </Paper>
            </Box>
        </Container>
    );
};

export default VerifyEmail;
